import React from 'react';
import {TimePicker} from '@alicd/next';
import FormItem from '@alicd/crui-form-item';

class TimePickerField extends React.Component {
  render() {
    /* eslint-disable */
    const {bind, style, inputStyle, init, ...other} = this.props;
    const {labelCol, wrapperCol, mapping, className, ...otherInput} = other;
    /* eslint-enable */

    return (<FormItem {...other} style={style}><TimePicker {...otherInput} style={inputStyle}/></FormItem>);
  }
}
export default TimePickerField;



// WEBPACK FOOTER //
// ./src/index.jsx